import { useEffect } from "react";
import { AppError, loggerService } from "../../infra";
import { mapToCopyFile } from "../../infra/locales/types";
import { sharedEnvironment } from "../../config";
import { useLocaleStore } from "../hooks";
import { useCmsCopyStore } from "../hooks/useCmsCopyStore";
import { useFetchLocaleCopy } from "../hooks/useFetchLocaleCopy";
import { useLocaleCopyStore, type CopyFile } from "../hooks/useLocaleCopyStore";

export function LocaleBootstrapper({ slugPrefixes }: Readonly<{ slugPrefixes: string[] }>) {
  const { locale } = useLocaleStore();
  const { data, isLoading } = useFetchLocaleCopy(slugPrefixes);
  const { setCmsCopy, setIsLoadingCmsCopy } = useCmsCopyStore(state => state.actions);
  const { setLocaleCopy, setIsLoadingLocaleCopy } = useLocaleCopyStore();

  useEffect(() => {
    setIsLoadingLocaleCopy(isLoading);
    setIsLoadingCmsCopy(isLoading);
  }, [isLoading, setIsLoadingLocaleCopy, setIsLoadingCmsCopy]);

  useEffect(() => {
    if (!data) return;

    setCmsCopy(data);
    loggerService.debug("setting locale data", data);

    const mapper = mapToCopyFile[sharedEnvironment.appName as keyof typeof mapToCopyFile];
    const rawLocaleCopy = data.localeCopy;
    if (!mapper || !rawLocaleCopy) {
      loggerService.error(new AppError("LocaleCopyMappingUnavailable", JSON.stringify({
        appName: sharedEnvironment.appName,
        hasLocaleCopy: Boolean(rawLocaleCopy),
      })),
      );
      return;
    }

    setLocaleCopy(mapper(rawLocaleCopy) as CopyFile);
  }, [data, setCmsCopy, setLocaleCopy, locale]);

  return null;
}
